import { ReducerCreators } from '@reduxjs/toolkit';

import { Get } from '@/connection/helpers';
import { RootState } from '@/store/main';
import { BtvChannelCategoriesState, BtvChannelCategory } from './types';

const BTV_API_HOST = `https://api.${import.meta.env.VITE_BRAND_TV_DOMAIN}`;

type BtvChannelCategoriesResponse = {
  status: boolean;
  success: {
    code: string;
    message: string;
    data: {
      list: BtvChannelCategory[];
      total: number;
      page: number;
      limit: number;
    };
  };
  error: null | string;
};

export const reducers = (create: ReducerCreators<BtvChannelCategoriesState>) => ({
  fetchBtvChannelCategories: create.asyncThunk(
    async (_: void, { getState, rejectWithValue }) => {
      const state = getState() as RootState;
      const existing = state.btvChannelCategories.btvChannelCategories;
      if (existing) return existing;

      try {
        const res = await Get<BtvChannelCategoriesResponse>({
          host: BTV_API_HOST,
          path: '/api/v1/dash/category?limit=1000',
        });

        return res.success.data.list;
      } catch (e) {
        return rejectWithValue(e);
      }
    },
    {
      fulfilled: (state, action) => {
        state.btvChannelCategories = action.payload;
        state.loadingBtvChannelCategories = false;
      },
      pending: (state) => {
        state.loadingBtvChannelCategories = true;
      },
      rejected: (state, action) => {
        state.loadingBtvChannelCategories = false;
        console.error(action.error);
      },
    }
  ),
});
